import { render } from "./PrintRequisition.vue?vue&type=template&id=beb774aa"
import script from "./PrintRequisition.vue?vue&type=script&lang=js"
export * from "./PrintRequisition.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/cases/PrintRequisition.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "beb774aa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('beb774aa', __exports__)) {
    console.log('reload')
    api.reload('beb774aa', __exports__)
  }
  
  module.hot.accept("./PrintRequisition.vue?vue&type=template&id=beb774aa", () => {
    console.log('re-render')
    api.rerender('beb774aa', render)
  })

}


export default __exports__